import * as tslib_1 from "tslib";
import { formApi } from "../../../../../api";
import MutilText from "../../../../../form/src/common/components/mutil-text.vue";
import { TextInputControl } from "../../../../../form/src/common/controls/input-controls/text-input-control";
import { RelevanceFormControl } from "../../../../../form/src/common/controls/relevance-form-control";
import { H3Input, H3Textarea } from "h3-mobile-vue";
import { Component } from "vue-property-decorator";
let MobileInputText = class MobileInputText extends TextInputControl {
    constructor() {
        super(...arguments);
        this.showTip = "";
        this.focus = false;
        this.timer = null;
        this.timerNew = null;
        // 是否启用数据字典
        this.isUseDataDictionary = false;
        this.dictionaryId = "";
        this.inputId = +new Date() + "";
        this.dictionaryData = []; // 数据字典数据
        this.useDictionariesData = [];
    }
    onFocus() {
        this.focus = true;
    }
    onBlur() {
        super.validate();
        setTimeout(() => {
            this.focus = false;
        }, 300);
    }
    scan() {
        RelevanceFormControl.service.scan(this.setVal);
    }
    get isCrossEntityText() {
        if (this.val) {
            try {
                const parsedArr = JSON.parse(this.val);
                return parsedArr instanceof Array && parsedArr && parsedArr.length
                    && parsedArr[0].hasOwnProperty('id') && parsedArr[0].hasOwnProperty('name') && parsedArr[0].hasOwnProperty('type');
            }
            catch (e) {
                return false;
            }
        }
        return false;
    }
    get crossEntityStaff() {
        if (this.isCrossEntityText) {
            try {
                const parsedArr = JSON.parse(this.val);
                return parsedArr;
            }
            catch (e) {
                return [];
            }
        }
        return [];
    }
    setVal(val) {
        this.ctrl.value = val.length === 0 ? null : val;
        this.val = this.ctrl.value;
        if (!val) {
            return;
        }
        setTimeout(() => {
            let h3Input = this.$refs.h3Input;
            if (h3Input && h3Input.onInputChange) {
                // h3Input.onInputChange(val);
                const textinput = h3Input.$refs.textinput;
                if (textinput && textinput.reSetHeight) {
                    textinput.reSetHeight(textinput.$refs.textarea);
                }
            }
        }, 50);
    }
    onChange() {
        if (this.dictionaryId) {
            this.getDictionaryData();
        }
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            this.ctrl.value = this.val.length === 0 ? null : this.val;
            if (this.val.length >= this.maxLength) {
                this.showTip =
                    this.control.options && this.control.options.maxLengthTips
                        ? this.control.options.maxLengthTips
                        : "";
                if (this.showTip) {
                    this.$h3.toast.show({
                        text: "已到设置的最大数，提示语：" + this.showTip,
                    });
                    if (this.timerNew)
                        clearTimeout(this.timerNew);
                    this.timerNew = setTimeout(() => {
                        this.showTip = "";
                        this.$h3.toast.hide();
                    }, 3000);
                }
            }
        }, 500);
    }
    onChangeTextarea() {
        let el = this.$refs.h3Textarea.$el;
        let h = el.offsetHeight;
        el.style.height = `${el.offsetHeight}px`;
        this.ctrl.value = this.val.length === 0 ? null : this.val;
        setTimeout(() => {
            el.style.height = "auto";
        }, 16.66666666);
    }
    get isShowSearch() {
        return this.focus && this.filterDictionaryDataList.length && this.val !== "";
    }
    get filterDictionaryDataList() {
        if (this.val === "") {
            return this.dictionaryData;
        }
        return this.dictionaryData.filter((el) => !!~el.name.indexOf(this.val));
    }
    getDictionaryData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.dictionaryData.length) {
                return;
            }
            let res = yield formApi.getEnableRecordsByDictionaryId({
                dicId: this.dictionaryId,
            });
            if (res.errcode === 0) {
                this.dictionaryData = res.data;
            }
        });
    }
    checkData(name) {
        this.val = name;
        this.setValue(name);
    }
    created() {
        if (this.control.options &&
            this.control.options.dictionaryData &&
            this.control.options.dictionaryData.isUseDataDictionary) {
            this.isUseDataDictionary = true;
            try {
                let options = JSON.parse(this.control.options.dictionaryData.options.value);
                this.dictionaryId = options.checkedDictionary || "";
                this.useDictionariesData = options.useDictionariesData;
                this.dictionaryData = options.useDictionariesData;
            }
            catch (error) {
                console.log(error);
            }
        }
    }
};
MobileInputText = tslib_1.__decorate([
    Component({
        name: "mpbile-input-text",
        components: {
            H3Input,
            H3Textarea,
            MutilText,
        },
    })
], MobileInputText);
export default MobileInputText;
